const COMPOSER_MAX_LENGTH = 4096;

export function insertAtCaret(
  value: string,
  insert: string,
  selectionStart: number,
  selectionEnd: number,
  maxLength: number = COMPOSER_MAX_LENGTH,
): { value: string; caret: number } {
  const start = Math.min(Math.max(0, selectionStart), value.length);
  const end = Math.min(Math.max(start, selectionEnd), value.length);
  const available = maxLength - (value.length - (end - start));
  const nextInsert = available <= 0 ? "" : insert.slice(0, available);
  return {
    value: `${value.slice(0, start)}${nextInsert}${value.slice(end)}`,
    caret: start + nextInsert.length,
  };
}
